import { LayoutModule } from '@angular/cdk/layout';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { Router, RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './blocks/blocks.module';
import { AppComponent } from './blocks/root/app.component';
import { AccountSettingComponent } from './shared/components/account-setting/account-setting.component';
import { BankAccountComponent } from './shared/components/bank-account/bank-account.component';
import { ChangePasswordComponent } from './shared/components/change-password/change-password.component';
import { EditEmailComponent } from './shared/components/edit-email/edit-email.component';
import { EditPhoneNumberComponent } from './shared/components/edit-phone-number/edit-phone-number.component';
import { ConfirmationService } from 'primeng/api';
import { CorsInterceptor } from './shared/interceptors/cors.interceptor';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { SharedModule } from './shared/shared/shared.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AmazonFullPathPipe } from './shared/pips/amazon-full-path.pipe';
import { KycExpiredDialogComponent } from './shared/components/kyc-expired-dialog/kyc-expired-dialog.component';

@NgModule({
  declarations: [
    AmazonFullPathPipe, KycExpiredDialogComponent, AccountSettingComponent, ChangePasswordComponent,
  ],
  imports: [
    BlocksModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    ConfirmDialogModule,
    LayoutModule,
    NgxSpinnerModule.forRoot({
        type: 'ball-scale-multiple',
    }),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (TranslationLoaderFactory),
            deps: [HttpClient]
        }
    }),
    SharedModule,
    // Standalone now (needed via SharedModule imports for new Investor pages) but still used
    // via template selector inside AccountSettingComponent's (non-standalone) template.
    BankAccountComponent,
    EditEmailComponent,
    EditPhoneNumberComponent,
],
  providers: [
    TranslateStore,
    {
      'provide': APP_INITIALIZER,
      'useFactory': InitTranslation,
      'deps': [TranslateService],
      'multi': true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: CorsInterceptor, multi: true },
     ConfirmationService,
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(trace: Sentry.TraceService) {}
}

//platformBrowserDynamic().bootstrapModule(AppModule);

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function InitTranslation(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('ar');
    translate.use(translate.getDefaultLang());
    return Promise.resolve();
  };
}
